"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentMovedPayloadSchema = void 0;
var constants_1 = require("@hobt/constants");
var document_entity_record_schema_1 = require("./document-entity-record-schema");
exports.documentMovedPayloadSchema = {
    type: 'object',
    required: ['document'],
    properties: {
        claimID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        document: document_entity_record_schema_1.documentEntityRecordSchema,
        documentCreatedID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        generateClaimCoverLetter: {
            type: ['boolean', 'null'],
            errorMessage: 'Should be a boolean or null',
        },
        metadata: {},
        reportingPeriodID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        reportType: {
            type: 'number',
            enum: Object.values(constants_1.ReportType),
            errorMessage: 'Should equate to a valid ReportType Enum value',
        },
        requestLetterID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
    },
};
